import React, { useContext } from 'react';
import './ThreadListItem.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { format, subMinutes } from 'date-fns';
import { EnvironmentContext } from '../../contexts/EnvironmentContext';
import logComponent from '../../common/logComponent';

export default function ThreadListItem({ thread, onClick, selected }) {
  const environmentContext = useContext(EnvironmentContext);
  const { activeUser: user } = environmentContext;

  if (logComponent('ThreadListItem')) { console.debug('ThreadListItem rendered'); }

  const threadIsUnread = (thread) => {
    if (logComponent('ThreadListItem')) { console.debug('ThreadListItem threadIsUnread'); }

    if (user.groupTypeString === 'Family' && !thread.isReadByFamily) return true;
    if (user.groupTypeString === 'Facility' && !thread.isReadByFacility) return true;

    return false;
  }

  const handleClick = () => {
    if (logComponent('ThreadListItem')) { console.debug('ThreadListItem handleClick'); }
    onClick(thread);
  }

  const getTimeZoneAdjustedLastActive = () => {
    if (logComponent('ThreadListItem')) { console.debug('ThreadListItem getTimeZoneAdjustedLastActive'); }

    const date = new Date(thread.lastActive);
    const tzOffset = date.getTimezoneOffset();
    const tzAdjustedDate = subMinutes(date, tzOffset);

    return format(tzAdjustedDate, 'MMMM d, yyyy h:mm aaa');
  }


  return (
    <li key={thread.threadId} className={'Thread-List-Item' + (selected ? ' Thread-List-Item--selected' : '')}>
      <button
        onClick={handleClick}>
        <div className="Thread-List-Item__info">
          <p className="Thread-List-Item__subject">{thread.subject}</p>
          <p className="Thread-List-Item__time">{getTimeZoneAdjustedLastActive()}</p>
          <p className="Thread-List-Item__thread-type">{thread.isPrivate ? 'Direct message' : 'Family message'}</p>
        </div>
        {
          threadIsUnread(thread) &&
          <FontAwesomeIcon icon="circle" className="Thread-List-Item__unread-icon" />
        }
      </button>
    </li>

  );
}